import { useState, useSyncExternalStore } from 'react';
import { checkAvailability, getAvailability, subscribeAvailability } from './api-availability';
import './maintenance.css';

export default function MaintenanceBoundary({ children }) {
  const problem = useSyncExternalStore(subscribeAvailability, getAvailability);
  const [checking, setChecking] = useState(false);
  const [failed, setFailed] = useState(false);

  const retry = async () => {
    setChecking(true);
    setFailed(false);
    if (await checkAvailability()) {
      window.location.reload();
      return;
    }
    setFailed(true);
    setChecking(false);
  };

  return <>
    <div style={{display: problem ? 'none' : 'contents'}}>{children}</div>
    {problem && <main className="maintenance-page">
      <section className="maintenance-card" aria-labelledby="maintenance-title">
        {/* <div className="maintenance-symbol" aria-hidden="true">{problem === 'offline' ? '↯' : '✳'}</div> */}
        <p className="maintenance-brand">Vlink</p>
        <h1 id="maintenance-title">{problem === 'offline' ? 'Нет подключения к интернету' : 'Ведутся технические работы'}</h1>
        <p className="maintenance-description">{problem === 'offline'
          ? 'Проверьте подключение и попробуйте ещё раз.'
          : 'Сервис временно недоступен. Пожалуйста, попробуйте зайти немного позже.'}</p>
        <button type="button" onClick={retry} disabled={checking}>
          {checking ? 'Проверяем…' : 'Попробовать снова'}
        </button>
        <p className="maintenance-status" role="status" aria-live="polite">
          {failed ? 'Соединение пока не восстановлено. Попробуйте чуть позже.' : '\u00a0'}
        </p>
      </section>
    </main>}
  </>;
}
